import { paymentMethods } from "../../models/PaymentMethods";

// Material UI
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from '@mui/material/styles';

// Icons
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LocalAtmIcon from '@mui/icons-material/LocalAtm'
import LinkIcon from '@mui/icons-material/Link';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { ReactComponent as PosnetIcon } from '../../icons/posnet.svg';
import { ReactComponent as QrCodeIcon } from '../../icons/qr-code.svg';
import { ReactComponent as CheckIcon } from '../../icons/check.svg';

const PaymentMethodButton = ({ paymentMethod, isSelected, onClick, ...rest }) => {
    const theme = useTheme();

    const renderIcon = () => {
        switch (paymentMethod.value) {
            case paymentMethods.Cash:
                return <LocalAtmIcon />;
            case paymentMethods.Posnet:
                return <PosnetIcon style={{ width: '1.45rem', height: '1.45rem', fill: isSelected ? theme.palette.primary.main : theme.palette.text.primary }} />;
            case paymentMethods.Card:
                return <CreditCardIcon />;
            case paymentMethods.TerminalQr:
                return (
                    <Grid container direction='row' alignItems='center' justifyContent='center' spacing={1}>
                        <Grid>
                            <PosnetIcon style={{ width: '1.45rem', height: '1.45rem', fill: isSelected ? theme.palette.primary.main : theme.palette.text.primary }} />
                        </Grid>
                        <Grid>
                            <QrCodeIcon style={{ width: '1.45rem', height: '1.45rem', fill: isSelected ? theme.palette.primary.main : theme.palette.text.primary }} />
                        </Grid>
                    </Grid>
                );
            case paymentMethods.Qr:
                return <QrCodeIcon style={{ width: '1.45rem', height: '1.45rem', fill: isSelected ? theme.palette.primary.main : theme.palette.text.primary }} />;
            case paymentMethods.Link:
                return <LinkIcon />;
            case paymentMethods.Check:
                return <CheckIcon style={{ height: '1.65rem', fill: isSelected ? theme.palette.primary.main : theme.palette.text.primary }} />;
            case paymentMethods.Transfer:
                return <AccountBalanceIcon />;
            default:
                return null;
        }
    }

    return (
        <Button
            variant='outlined'
            color={isSelected ? 'primary' : 'inherit'}
            style={{
                textTransform: 'none',
                width: '120px',
                maxHeight: '70px'
            }}
            onClick={() => onClick(paymentMethod.value)}
        >
            <Grid container direction='column' alignItems='center' style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
                {renderIcon()}
                <Typography variant='body2' color={isSelected ? 'primary' : 'inherit'}>
                    {paymentMethod.title}
                </Typography>
            </Grid>
        </Button>
    );
}

export default PaymentMethodButton;